import { set } from 'date-fns';

import { formatTime } from 'state/intl/translations';

/**
 * Converts a time string of any common format into a localised display string.
 *
 * Supported input formats:
 *  - `HH:mm`            e.g. "10:30"
 *  - `HH:mm:ss`         e.g. "10:30:00"
 *  - `HH:mm:ss.SSS`     e.g. "10:30:00.500"
 *  - `HH:mm:ss±HH:MM`   e.g. "10:30:00+05:00" (timezone offset is ignored)
 *  - Single-digit hour  e.g. "9:05"
 *
 * For any unrecognised format (e.g. 12-hour AM/PM, empty string, or non-time
 * values) the raw `time` string is returned unchanged.
 *
 * @param time - A time string to format.
 * @returns The localised time string, or the original `time` value if parsing fails.
 */
export const timeToString = (time: string) => {
  try {
    const [hours, minutes] = time.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) {
      return time;
    }
    return formatTime(set(new Date(), { hours, minutes, seconds: 0, milliseconds: 0 }));
  } catch {
    return time;
  }
};
